import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  inputFieldBarcode: {
    minWidth: '100%',
  },
  btns: {
    minWidth: '100%',
    display: "flex",
    height: 38,
  },
  btnSearchBarcode: {
    justifyContent: "flex-end",
  },
  snackbar: {
    position: "relative",
    paddingTop: "10px"
  },
}));

export default useStyles;
